<template>
	<div>
		<div v-if="!mode" style="display: flex; justify-content: space-between;">
			<b-button
				v-b-toggle="className"
				block
				class="panel-item-header-button"
			>
				<div style="display: flex">
					<span class="panel-item-header-trigger-icon" />
					<span class="panel-item-header-title">
						<h5 style="margin-bottom: 0px;"> {{ displayDataEdit.type || 'No Program Type' }} </h5>
					</span>
				</div>
			</b-button>
			<div class="program-type">
				<b>{{ displayDataEdit.category || 'No Program Category' }}</b>
			</div>
		</div>

		<b-collapse :id="className" v-model="visible">
			<b-container>
				<b-row v-if="!mode"> 
					<b-col>
						<b>Description</b>
					</b-col>
				</b-row>
				<b-row v-if="!mode"> 
					<b-col>
						{{ displayDataEdit.description || 'No description' }}
					</b-col>
				</b-row>

				<b-row v-if="mode">
					<b-col>
						Program Category
						<b-form-select
							id="input-category"
							v-model="displayDataEdit.category"
							:options="categories"
							size="sm"
						/>
					</b-col>
				</b-row>
					
				<b-row v-if="mode"> 
					<b-col>
						Program Type
						<b-form-select
							id="input-type"
							v-model="displayDataEdit.type"
							:options="types"
							size="sm"
						/>
					</b-col>
				</b-row>

				<b-row v-if="mode"> 
					<b-col>
						Description
						<b-form-textarea
							id="input-description"
							v-model="displayDataEdit.description"
							size="sm"
							placeholder="Enter description"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<h5> Configuration </h5>
					</b-col>
					<b-col>
						<b-form-datepicker
							v-if="mode"
							id="datepicker_asofdate"
							v-model="displayDataEdit.asOfDate"
							size="sm" 
							locale="en"
							placeholder="No date selected"
							:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						/>
						<b-icon 
							v-if="!mode"
							v-b-tooltip.hover.top="formatDate(displayDataEdit.asOfDate)"
							icon="clock"
							style="margin-bottom: 0.7rem !important;float: right;"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<b> Area </b>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.floorArea"
							:mode="mode"
							:step="0.01"
							label="Floor Area"
							unit="ft.^2"
						/>
					</b-col>
					<b-col>
						<field-input
							v-model="displayDataEdit.pctOfAssetFloorArea"
							:mode="mode"
							:step="0.01"
							label="% of Asset Floor Area"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<b> Efficiency </b>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.rentableArea"
							:mode="mode"
							:step="0.01"
							label="Rentable Area"
							unit="ft.^2"
						/>
					</b-col>
					<b-col>
						<field-input
							v-model="displayDataEdit.usableArea"
							:mode="mode"
							:step="0.01"
							label="Usable Area"
							unit="ft.^2"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.rentableUsableFactor"
							:mode="mode"
							:step="0.01"
							label="R/U Factor"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<b> Units </b>
					</b-col>
				</b-row>

				<b-row>
					<b-col>
						<field-input
							v-model="displayDataEdit.unitCount"
							:mode="mode"
							label="Count"
						/>
					</b-col>
					<b-col>
						<field-input
							v-model="displayDataEdit.pctOfAssetUnits"
							:mode="mode"
							:step="0.01"
							label="% Of Asset Unit Count"
						/>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row>
					<b-col>
						<h5> Unit Types </h5>
					</b-col>
				</b-row>
				
				<b-row v-if="displayDataEdit.unittypes.length === 0">
					<b-col>
						No Unit Types
					</b-col>
				</b-row>

				<b-row v-for="(unittype, id) in displayDataEdit.unittypes" :key="unittype.id">
					<b-col>
						<unit-type-view
							:index="id"
							:unittype="unittype"
							:mode="mode"
							class="unit-type-view"
							@remove="refresh()"
						/>
						<div v-if="id !== displayDataEdit.unittypes.length" style="height: 15px;" />
					</b-col>
				</b-row>

				<b-row v-if="mode"> 
					<b-col>
						<b-button block @click="addUnitType()">
							Add Unit Type
						</b-button>
					</b-col>
				</b-row>

				<b-row>
					<b-col style="height: 15px" />
				</b-row>

				<b-row v-if="mode"> 
					<b-col>
						<b-button block style="background-color: #FFAAAA; color: #000000;" @click="remove()">
							Remove Program
						</b-button>
					</b-col>
				</b-row>
			</b-container>
		</b-collapse>
	</div>
</template>

<script>
import UnitTypeView from './UnitTypeView.vue';

export default {
    name: 'ProgramTypeview',
	components: { UnitTypeView },
    filters: {},
	props: {
        program: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true
        },
		mode: {
			type: Boolean,
			required: false
		}
	},   
    data() {
        return {
            className: '',
			displayDataEdit: {},
			categories: [
				{ value: 'Residential', text: 'Residential' },
				{ value: 'Commercial', text: 'Commercial' },
				{ value: 'Industrial', text: 'Industrial' }
			],
			types: [
				{ value: 'Multifamily', text: 'Multifamily' },
				{ value: 'Affordable', text: 'Affordable' },
				{ value: 'Hotel', text: 'Hotel' },
				{ value: 'Office', text: 'Office' },
				{ value: 'Retail', text: 'Retail' },
				{ value: 'Manufacturing', text: 'Manufacturing' },
				{ value: 'Warehouse / Distribution', text: 'Warehouse / Distribution' }
			],
			visible: false
        }
    },
    computed: {
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
		}
	},
    watch: {
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		program: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		},
		mode: {
			immediate: true,
			handler(newVal) {
				if (newVal) this.visible = newVal;
			},
		},
        index: {
			immediate: true,
			handler(newVal) {
				this.className = `program_collapse_${newVal}`;
			},
		}
	},
	created() {
		
	},
    mounted() {
	},
    methods: {
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const updateAssetProgramModelData = await this.axios.patch(
					`/assetprograms/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		async remove() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const deleteAssetProgramModelData = await this.axios.delete(
					`/assetprograms/${this.displayDataEdit.id}`
				);
				this.$emit('remove');
			}
		},
		async addUnitType() {
			const newUnitType = {
				name: "",
				description: "",
				asOfDate: null,
				averageArea: 0,
				minimumArea: 0,
				maximumArea: 0,
				count: 0,
				pctOfProgram: 0,
				assetprogramId: this.displayDataEdit.id
			}
			const postAssetUnitTypeModelData = await this.axios.post(
				`/unittypes`,
				newUnitType
			);
			this.displayDataEdit.unittypes.push(postAssetUnitTypeModelData.data);
		},
		refresh(index) {
			this.displayDataEdit.unittypes.splice(index, 1);
		}
    }
};
</script>

<style scoped>
.btn {
	border: none;
    outline: none;
}
.btn:focus {
    box-shadow: none;
	outline: none;
}
.btn:focus-visible {
    outline: 0;
    border-radius: 0;
}
.btn:hover {
    color: #fff;
    text-decoration: none;
}
.btn-secondary {
	border: none;
    outline: none;
}
.btn-secondary:focus {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
	outline: 0;
}
.btn-secondary:hover {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: transparent;
    border-color: transparent;
	outline: none;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
    box-shadow: none;
}
.btn-secondary:focus-visible {
    outline: 0;
    border-radius: 0;
}
.panel-item-header-button {
	width: 50%;
    background-color: transparent;
}
.panel-item-header-title {
    bottom: 2px;
}
div.unit-type-view {
    border-radius: 12px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #e4e4e4;
}
.collapsed .when-open,
.not-collapsed .when-closed {
  display: none;
}
.program-type {
    border-radius: 9px;
    border: 1px solid #000000;
    padding: 5px;
	background-color: #647882;
    color: #ffffff;
	margin-right: 7px;
    margin-top: 2px;
}
</style>

<style lang="scss">
</style>